
const despesaGridConfig = {
  idField: "idDespesa",
  columns: [
    { header: "Descrição", field: "DESCRICAO" },
    { header: "Vencimento", field: "DATA_VENCIMENTO" },
    { header: "Pago", field: "PAGO",
      formatter: (value) => (value ? "Sim" : "Não")
    },
    { header: "Pagamento", field: "data_pagamento" },
    { header: "Valor", field: "valor" }, 
    { header: "Ativo", field: "ATIVO",
      formatter: (value) => (value ? "Sim" : "Não")
    }
  ]
};

export default despesaGridConfig